import './quick-contacts.less';

// trim-below
import React, {Component} from 'react';
import block from 'bem-cn-lite';

const b = block('quick-contacts');

class QuickContacts extends Component {
	render() {
		return (
			<div className={b()}>
				<div className={b('item')} itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
					<svg className={b('icon')} viewBox="0 0 24 24" width="24">
						<path d="M21,3L3,10.53V11.5L9.84,14.16L12.5,21H13.46L21,3Z" />
					</svg>
					<span className={b('label')}>Γραφεία:</span>
					<span className={b('caption')}><span itemProp="streetAddress">Κνωσού 15</span>, <span itemProp="addressLocality">Ηράκλειο</span></span>
				</div>
				<div className={b('item')}>
					<svg className={b('icon')} viewBox="0 0 24 24" width="24">
						<path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
					</svg>
					<span className={b('label')}>Τηλέφωνο:</span>
					<a className={b('caption', {'phone': true})} href="tel:+30 2810 284040"><span itemProp="telephone">2810 284040</span></a>
				</div>
				<div className={b('item')}>
					<svg className={b('icon')} viewBox="0 0 24 24" width="24">
						<path d="M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4M12,11L20,6H4L12,11M4,18H20V8.37L12,13.36L4,8.37V18Z" />
					</svg>
					<span className={b('label')}>e-mail:</span>
					<a href="mailto:info@skouras.eu" className={b('caption', {'email': true})} itemProp="email">info@skouras.eu</a>
				</div>
			</div>
		);
	}
}

export default QuickContacts;



// WEBPACK FOOTER //
// ./src/components/header/quick-contacts/index.jsx